<template>
  <div class="">
    <div v-if="isShow" class="">
      <div class="bg_white mt12 pt20 pb36">
        <h2 class="page_title small ab ml16 mr16">お振込先口座確認</h2>
        <div v-if="!checkAccount()" class="">
          <BankData :isConfirm="false" />
          <div class="btn_wrap">
            <router-link class="btn_blue ab bank_btn" :to="{ name: 'WalletWithdraw', params: {} }">出金額を入力する</router-link>
          </div>
        </div>
        <div v-else class=" pl16 pr16 mt16">
          <p class="ab c5a">口座のご登録がございません。<br>口座情報のご登録をお願いします</p>
          <div class="btn_wrap">
            <router-link class="btn_blue ab bank_btn" :to="{ name: 'editBankAccount', query: {redirect_url: 'WalletWithdrawBankCheck'} }">口座情報を登録する</router-link>
          </div>
        </div>

      </div>

    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </div>
</template>

<script>
import Check from '@/model/getToken';
import SectionTitle from '@/components/common/SectionTitle';
import BankAccount from '@/components/api/bankAccount';
import BankData from '@/components/wallet/WithdrawBank';
import { mapGetters } from 'vuex';

export default {
  components: {
    SectionTitle,
    BankData,

  },
  data() {
    return {
      isShow: true,
      isErrorModal: false,
      errorMessage: '',
      isDialogModal: false,
      DialogMessage: '',
    }
  },
  methods: {
    checkAccount() {
      return this.checkYucho() && this.checkOtherYucho();
    },
    checkYucho() {
      return this.bankAccount.postOfficeNumber == null || this.bankAccount.postOfficeNumber == '' || this.bankAccount.postOfficeSign == null || this.bankAccount.postOfficeSign == '';
    },
    checkOtherYucho() {
      return this.bankAccount.accountNumber == null ||
             this.bankAccount.accountNumber == '' ||
            this.bankAccount.accountType == null ||
            this.bankAccount.accountType == '' ||
            this.bankAccount.bank.bankCode == null ||
            this.bankAccount.bank.bankCode == '' ||
            this.bankAccount.branch.branchCode == null ||
            this.bankAccount.branch.branchCode == '';
    },
    isDialogClose() {
      this.isDialogModal = false;
    },
    isDialogCloseTransition() {
      this.isDialogModal = false;
      // 口座登録されていなかったら登録画面に遷移
      this.$router.push({ name: 'editBankAccount', query: {redirect_url: 'WalletWithdraw'} });
    },
    modalClose() {
      this.isErrorModal = false;
    },

  },
  computed: mapGetters(['bankAccount']),
  async created() {
    let res;
    await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
    if(res) {
      await BankAccount.getBankAccount().then((val) => {
        console.log('出金口座情報');
        console.log(val);
        this.$store.commit('setWithdrawBankAccount', val.bankAccount);
      });
    } else {
      this.isShow = false;
    }
  },
}
</script>

<style lang="css" scoped>
.page_title.small {
  font-size: 14px;
}
.amount {
  align-items: center;
  display: flex;
  font-size: 18px;
  justify-content: flex-end;
  padding-bottom: 8px;
}
.amount .yen {
  font-size: 14px;
  margin-left: 2px;
}
.bonus_content {
  font-size: 14px;
}

.bonus_label.disabled {
  position: relative;
}
.bonus_label.disabled::before {
  background-color: #aaa;
  content: '';
  height: 100%;
  left: 0;
  opacity: .5;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 4;
}

.bonus_text {
  font-size: 12px;
  margin-top: 5px;
  margin-left: 28px;
}
.alert {
  color: red;
}

.input_wrap {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}
.withdraw_price {
  border-width: 2px;
  width: 93.5%;
}
.input {
  border: none;
  color: #4FCCD4;
  font-size: 30px;
  width: 100%;
}
.input_wrap .yen {
  margin-left: 8px;
}

.bonus_date {
  font-size: 14px;
  margin-top: 5px;
  margin-left: 28px;
}
/* .bonus {
  margin-top: 29px;
  margin-left: 44px;
  margin-right: 16px;
}
.bonus_list {
  display: flex;
  justify-content: space-between;
  line-height: 1;
  margin-top: 13px;
}

.bonus .bonus_list:last-child {
  border-top: 1px solid  #c9c9c9;
  padding-top: 10px;
}

.bonus_title {
  font-size: 14px;
}
.bonus_price {
  align-items: center;
  display: flex;
  font-size: 16px;
}

.bonus_price .yen {
  font-size: 12px;
  margin-left: 2px;
} */

.bank .bonus_price {
  font-size: 14px;
}

.bank_detail {
  border-top: 1px solid  #c9c9c9;
  border-bottom: 1px solid  #c9c9c9;
}
.detail_title {
  font-size: 12px;
  line-height: 1;
}
.detail_text {
  font-size: 12px;
  margin-top: 5px;
}
.detail_text:not(:first-child) {
  margin-top: 16px;
}

.btn_wrap {
  margin-top: 16%;
}
.bank_btn {
  letter-spacing: 5.5px;
}
</style>



// WEBPACK FOOTER //
// src/views/wallet/withdraw/WithdrawBankCheck.vue